module.exports = __webpack_public_path__ + "media/Bootmusic.fc1e8211.mp3";